import { Base, BaseActionTypes, GeneralBaseAction } from '../../types';

const defaultState: Base = {
  loading: true,
};

// actions
export const actions = {
  startLoading: (): GeneralBaseAction => ({ type: BaseActionTypes.START_APP_LOADING }),
  stopLoading: (): GeneralBaseAction => ({ type: BaseActionTypes.STOP_APP_LOADING }),
};

// reducers
export const base = (state: Base = defaultState, action: GeneralBaseAction): Base => {
  switch (action.type) {
    case BaseActionTypes.STOP_APP_LOADING:
    case BaseActionTypes.START_APP_LOADING:
      return {
        ...state,
        loading: action.type === BaseActionTypes.START_APP_LOADING,
      };
    default:
      return state;
  }
};
